let ExperimentServer
if (typeof window === 'undefined') {
  ExperimentServer =
    require('@amplitude/experiment-node-server').Experiment.initialize(process.env.AMPLITUDE_API_KEY, {})

  ExperimentServer['_logger'] = {
    ...ExperimentServer['_logger'],
    logEvent: () => {},
    setUserProperties: () => {},
  }
}

export { ExperimentServer }
